import { createSelector } from 'reselect';
import { relativeContextReducerKey } from './RelativeContextConstants';

export function hitSetKey(state, ownProps) {
  return ownProps.hitSetKey;
}

export function relativeContext(state) {
  return state.get(relativeContextReducerKey);
}

// eslint-disable-next-line no-shadow
export const relativeContextByHitSetKey = createSelector([relativeContext, hitSetKey], (relativeContext, hitSetKey) =>
  relativeContext.get(hitSetKey)
);

// eslint-disable-next-line no-shadow
export const orderedRelativeContextByHitSetKey = createSelector([relativeContextByHitSetKey], (relativeContextByHitSetKey) => {
  if (!relativeContextByHitSetKey) {
    return null;
  }

  const items = relativeContextByHitSetKey.get('items');
  const ids = relativeContextByHitSetKey.get('ids');

  return ids.map((id) => items.get(id));
});

export function relativeContextItemsByHitSetKey(state, ownProps) {
  const result = relativeContextByHitSetKey(state, ownProps);

  if (!result) {
    return null;
  }

  return result.get('items');
}
